import { Component, OnInit, forwardRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavController, NavParams, ModalController, LoadingController, ToastController, AlertController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EditorHtmlPage } from '../../editor-html/editor-html.page';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { UserProvider } from 'src/app/services/user/user';
import { CommonModule } from '@angular/common';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { MoneyPipe } from 'src/app/pipes/money/money';
import { ConfigProvider } from 'src/app/services/config/config';

@Component({
  selector: 'app-grupo-resumo',
  templateUrl: './grupo-resumo.page.html',
  styleUrls: ['./grupo-resumo.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ReactiveFormsModule,
    NomenclaturaPipe,
    MoneyPipe
  ],
})
export class GrupoResumoPage implements OnInit {
  validations_form: FormGroup;
  readOnly = false;
  idReuniao: string;
  reuniao: any = {};
  possuiCusto: boolean = false;
  supervisao: boolean = false;
  status: any = 0;
  resumoData: any;
  loader = this.loadingController.create({
    message: this.translate.instant("Carregando")
  });
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public loadingController: LoadingController,
    public grupoProvider: GrupoProvider,
    public formBuilder: FormBuilder,
    public toastCtrl: ToastController,
    private translate: TranslateService,
    private alertCtrl: AlertController,
    public userProvider: UserProvider,
    public configProvider: ConfigProvider,
  ) {
    this.idReuniao = this.navParams.get('idReuniao');
    this.readOnly = this.navParams.get('readOnly');

    this.validations_form = this.formBuilder.group({
      status: new FormControl({ value: '0', disabled: this.readOnly }),
      resumo: new FormControl({ value: '', disabled: this.readOnly }),
      numCriancas: new FormControl({ value: '', disabled: this.readOnly }),
      quilos_doados: new FormControl({ value: '', disabled: this.readOnly }),
      idPossuiCusto: new FormControl({ value: '', disabled: this.readOnly }),
      valorOferta: new FormControl({ value: '', disabled: this.readOnly }),
      supervisao: new FormControl({ value: '', disabled: this.readOnly }),
      supervisaoNome: new FormControl({ value: '', disabled: this.readOnly }),
      numVisitantes: new FormControl({ value: '', disabled: this.readOnly }),
    });
  }

  ngOnInit() {
  }

  ionViewDidEnter() {
    this.grupoProvider.salvarStatus(this.idReuniao).subscribe((data) => {
      this.grupoProvider.getReuniao(this.idReuniao).subscribe((data) => {
        this.supervisao = data.supervisao == '1' ? true : false;
        this.possuiCusto = data.idPossuiCusto == 1 ? true : false;
        this.reuniao = data;
        this.validations_form.controls['status'].setValue(data.status);
        this.validations_form.controls['resumo'].setValue(data.resumo);
        this.validations_form.controls['supervisao'].setValue(data.supervisao == '1');
        this.validations_form.controls['supervisaoNome'].setValue(data.supervisaoNome);
        this.validations_form.controls['numCriancas'].setValue(data.numCriancas == 0 ? '' : data.numCriancas)
        this.validations_form.controls['numVisitantes'].setValue(data.numVisitantes == 0 ? '' : data.numVisitantes);
        this.validations_form.controls['quilos_doados'].setValue(data.quilos_doados == 0 ? '' : data.quilos_doados);
        this.validations_form.controls['idPossuiCusto'].setValue( data.idPossuiCusto == 1 ? String(data.idPossuiCusto) : 0);
        this.validations_form.controls['valorOferta'].setValue(data.custo == 0 ? '' : String(data.custo ?  this.setValorOfertaFromApi(data) : ''));
      });

    });
  }

  async setValorOfertaFromApi(data: any) {
    const value = Number(data?.valorOferta || 0);

    if (!value) {
      this.validations_form.get('valorOferta')?.setValue('');
      return;
    }

    const cents = Math.round(value * 100);
    const formatted = await new MoneyPipe(this.configProvider).transform(cents);

    this.validations_form.get('valorOferta')?.setValue(formatted, { emitEvent: false });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  public async detalhes() {
    if (this.readOnly) {
      var d = { html: ('<p>' + this.reuniao.resumo + '</P>'), titulo: this.translate.instant('Detalhes do Resumo'), readOnly: true, justText: true };
      const modalPage = await this.modalCtrl.create({ component: EditorHtmlPage, componentProps: d });
      modalPage.present();
    }
  }

  async onSubmit(reuniao: any) {

    if (reuniao.status == 1 && this.reuniao.numero_presentes == 0) {
      let alert = await this.alertCtrl.create({
        cssClass: "alerta-personalizado",
        mode: "ios",
        header: this.translate.instant('Atenção'),
        message: 'Deseja realmente salvar essa reunião como \'realizada\' sem nenhuma pessoa presente?',
        buttons: [
          {
            text: this.translate.instant('Não'),
            handler: () => { }
          },
          {
            text: this.translate.instant('Sim'),
            handler: () => {
              this.saveReuniao(reuniao);
            }
          }
        ]
      });
      alert.present();
    } else if (reuniao.status == 0 && this.reuniao.numero_presentes > 0) {
      let alert = await this.alertCtrl.create({
        cssClass: "alerta-personalizado",
        mode: "ios",
        header: this.translate.instant('Atenção'),
        message: 'Identificamos que há pessoas presentes nessa reunião, deseja realmente salva-la como \'agendada\'?',
        buttons: [
          {
            text: this.translate.instant('Não'),
            handler: () => { }
          },
          {
            text: this.translate.instant('Sim'),
            handler: () => {
              this.saveReuniao(reuniao);
            }
          }
        ]
      });
      alert.present();
    } else if (reuniao.status == 2 && !reuniao.resumo) {
      let alert = await this.alertCtrl.create({
        cssClass: "alerta-personalizado",
        mode: "ios",
        header: this.translate.instant('Atenção'),
        message: 'Necessário preencher o motivo do cancelamento da reunião',
        buttons: [
          {
            text: this.translate.instant('Entendi'),
            handler: () => { }
          }
        ]
      });
      alert.present();
    } else {
      this.saveReuniao(reuniao);
    }

  }

  isSupervisao(event: any) {
    this.supervisao = event.detail.checked;
  }

  oferta(event: any) {
    this.possuiCusto = event.detail.checked;
  }

  async formatValor(event: any) {
    const rawValue = event.target.value.replace(/\D/g, "");
    const formatted = await new MoneyPipe(this.configProvider).transform(+rawValue);

    this.validations_form
      .get("valorOferta")
      ?.setValue(formatted, { emitEvent: false });
  }

  saveReuniao(reuniao: any) {
    let valor: { replace: (arg0: RegExp, arg1: string) => number };
    valor = reuniao.valorOferta.replace(/\D+/g, "")

    this.reuniao.status = reuniao.status;
    this.reuniao.resumo = reuniao.resumo;
    this.reuniao.numCriancas = reuniao.numCriancas;
    this.reuniao.numVisitantes = reuniao.numVisitantes;
    this.reuniao.quilos_doados = reuniao.quilos_doados;
    this.reuniao.idPossuiCusto = reuniao.idPossuiCusto;
    this.reuniao.oferta = reuniao.idPossuiCusto == 1;
    this.reuniao.supervisao = reuniao.supervisao ? '1' : '0';
    this.reuniao.supervisaoNome = reuniao.supervisaoNome;
    this.reuniao.valorOferta = reuniao.idPossuiCusto == 1 ? valor : 0;

    this.grupoProvider.salvarReuniao(this.reuniao, this.idReuniao).subscribe(async () => {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant('Resumo da reunião atualizado com sucesso!'),
        duration: 3000
      });

      toast.present();
      this.modalCtrl.dismiss(this.reuniao);
    });
  }  
}
